import { useState } from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { ASSETS } from '@/assets';
import { OrderSection } from '@/components/OrderSection';
import { PetBackdrop } from '@/components/PetBackdrop';

const GALLERY = [
  { src: ASSETS.bottleHero, alt: 'Angry Tangerine bottle front' },
  { src: ASSETS.artMixSpray, alt: 'Angry Tangerine bottles with fresh oranges' },
  { src: ASSETS.artGallon, alt: 'One bottle makes 3.79 litres infographic' },
];

export const Spotlight = () => {
  const { t } = useLanguage();
  const [active, setActive] = useState(0);
  const checks = [t.hero.check1, t.hero.check2, t.hero.check3];
  return (
    <section id="product" className="py-24 px-4 sm:px-6 lg:px-8 border-b-2 border-brand-green/10 bg-brand-sand/60 relative overflow-hidden">
      <PetBackdrop src={ASSETS.dogTable} className="left-[-120px] top-[-60px] w-[620px] h-[620px] hidden lg:block" opacity={0.1} />
      <div className="max-w-7xl mx-auto relative z-10">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-orange mb-10">{t.nav.bottle}</p>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">

          <div className="lg:col-span-6 lg:sticky lg:top-28 space-y-4">
            <div className="rounded-3xl overflow-hidden border-2 border-brand-green/10 bg-brand-bone shadow-xl aspect-[4/5]">
              <img
                src={GALLERY[active].src}
                alt={GALLERY[active].alt}
                data-testid="gallery-main-img"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="grid grid-cols-3 gap-3">
              {GALLERY.map((g, i) => (
                <button
                  key={g.src}
                  type="button"
                  data-testid={`gallery-thumb-${i}`}
                  onClick={() => setActive(i)}
                  className={`rounded-xl overflow-hidden border-2 bg-brand-bone aspect-square transition-all ${
                    active === i ? 'border-brand-orange shadow-md' : 'border-brand-green/10 hover:border-brand-orange/50'
                  }`}
                >
                  <img src={g.src} alt={g.alt} className="w-full h-full object-cover" loading="lazy" />
                </button>
              ))}
            </div>
            <div className="flex flex-wrap gap-x-5 gap-y-2 pt-2 text-xs font-bold text-brand-green/70">
              {checks.map((c) => (
                <span key={c} className="inline-flex items-center gap-1.5">
                  <Check className="w-3.5 h-3.5 text-brand-orange" />{c}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6 relative">
            <OrderSection />
          </div>
        </div>
      </div>
    </section>
  );
};
